import styled, { css } from 'styled-components';

const QuoteText = styled.span`
  color: var(--grey700);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 114.286% */
  text-decoration-line: underline;
  ${(props) =>
    !!props.isDeprecated &&
    css`
      color: var(--grey500);
      font-weight: 400;
      line-height: normal;
      text-decoration-line: underline;
    `}
`;
export default QuoteText;
